<template>
  <div class="tab-test-scene">
    <div v-if="loadingTestQuestions" class="loading">{{ $tr('common.loading') }}</div>
    <div v-else-if="errorTestQuestions" class="error">
      {{ errorTestQuestions.message ? errorTestQuestions.message : errorTestQuestions}}
    </div>
    <Group v-else v-for="group in groups" :key="group.id" :group="group" />    
    <div v-if="loadingTestPictures" class="loading">{{ $tr('common.loading') }}</div>
    <div v-else-if="errorTestPictures" class="error">
      {{ errorTestPictures.message ? errorTestPictures.message : errorTestPictures}}
    </div>
    <Snapshots :snapshots="snapshots" v-else/>
  </div>
</template>

<script>
import Group from './Group.vue'
import Snapshots from './Snapshots.vue'

export default {
  name: 'response-tabs-test',

  components: {
    Group,
    Snapshots
  },

  props: {
    response: Object
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/shlumberger/response/testQuestions/fetch', this.response)
      this.$store.dispatch('process/shlumberger/response/testPictures/fetch', this.response)
    }
  },

  data () {
    return {
      selectedQuestion: null
    }
  },

  computed: {
    stateTestQuestions  () {
      return this.$store.state.process.shlumberger.response.testQuestions
    },

    stateTestPictures  () {
      return this.$store.state.process.shlumberger.response.testPictures
    },

    loadingTestQuestions  () {
      return this.stateTestQuestions.loading
    },

    loadingTestPictures  () {
      return this.stateTestPictures.loading
    },

    errorTestQuestions  () {
      return this.stateTestQuestions.error
    },

    errorTestPictures  () {
      return this.stateTestPictures.error
    },

    groups () {
      return this.stateTestQuestions.data ? this.stateTestQuestions.data.groups : []
    },

    snapshots () {
      return this.stateTestPictures.data ? this.stateTestPictures.data : []
    }
  },

  beforeMount () {
    this.fetch()
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../../../styles/colors.scss';

  .tab-test-scene {
    margin-left: 12px;
  }

  .error {
    color: $red-color
  }
</style>
